export const CBRE_FLOW_APPROVALS_FILTER_GET_ALL_LOOKUPS_SUCCESS =
    'CBRE-FLOW-APPROVAL-FILTER/GET_ALL_LOOKUPS_SUCCESS';
export const CBRE_FLOW_APPROVALS_FILTER_GET_ALL_LOOKUPS_FAILURE =
    'CBRE-FLOW-APPROVAL-FILTER/GET_ALL_LOOKUPS_FAILURE';
export const MODULE = 'cbre-flow-approvals-filter';